<template>
  <div class="animated fadeIn">
    <b-card border-variant="white">
      <b-row>
      <b-col sm="5"><label for="input-none"></label></b-col>
        <div class="ml-auto p-2 align-middle">
          <el-button type="warning" icon="el-icon-plus" circle v-on:click="addRoutine()"></el-button>
        </div>
      </b-row>
      <b-card-body>
        <b-row>
          <b-col>
            <div class="table-responsive">
              <b-table
                :items="routineSelf"
                :fields="routinesFields"
                :current-page="routineCurrentPage"
                :per-page="routinePerPage">
                <div slot="share" slot-scope="item" class="middle">
                  <p v-if="item.value == true" class='p-0 m-0'>公開</p>
                  <p v-else class='p-0 m-0'>非公開</p>
                </div>
                <div slot="done" slot-scope="item" style="">
                  <p v-if="item.value == true" class='p-0 m-0'>完了</p>
                  <p v-else class='p-0 m-0'>実施中</p>
                </div>
                <div slot="category" slot-scope="item">
                  <p class='p-0 m-0'>[{{categoryText(item.value)}}]</p>
                </div>
                <div slot="key" slot-scope="item">
                    <el-button type="success" icon="el-icon-edit" circle v-on:click="editRoutine(item.value)"></el-button>
                </div>
              </b-table>
            </div>
          <b-pagination align="center" size="sm" :total-rows="routineSelf.length" v-model="routineCurrentPage" :per-page="routinePerPage"></b-pagination>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  data () {
    return {
      routinesFields: {
        title: {
          label: 'ルーティン',
          class: 'text-left',
          sortable: true
        },
        category: {
          label: 'カテゴリー',
          class: 'text-center',
          sortable: true
        },
        share: {
          label: '公開/非公開',
          class: 'text-center'
        },
        done: {
          label: '完了',
          class: 'text-center',
          sortable: true
        },
        key: {
          label: ''
        }
      },
      routineCurrentPage: 1,
      routinePerPage: 10,
      unsubscribe: null
    }
  },
  beforeDestroy () {
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  },
  created () {
    this.init()
  },
  computed: {
    ...mapGetters({
      routines: 'routine/routines',
      routineGroups: 'routineGroup/routineGroups',
      routineRefs: 'routineRef/routineRefs',
      routineSelf: 'routineSelf/routineSelf',
      user: 'authUser/user'
    })
  },
  methods: {
    init () {
    },
    editRoutine (parameter) {
      this.$store.dispatch('dispatch/setRoutine', parameter).then(() => {
        this.$router.push({path: 'routine/routine'})
      })
    },
    addRoutine () {
      this.$store.dispatch('dispatch/setRoutine', null).then(() => {
        this.$router.push({path: 'routine/routine'})
      })
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY/MM/DD HH:mm')
    },
    momentShort: function (date) {
      return moment(date).format('YYYY/MM/DD')
    }
  }
}
</script>

<style lang="scss">
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
th {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/RoutineSelf.vue